import React, { useEffect } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { useNavigate } from "react-router-dom";

const AuctionSuccessModal = React.forwardRef((props, ref) => {
  const navigate = useNavigate();

  // Handle form OK
  const okConfirm = async () => {
    navigate(props?.nextnavigate);
    props.onHide();
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="md"
      ref={ref}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <i className="bi bi-check2-circle"></i>
          <span className="modal-title"> {props?.successmodaldata?.title}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        <form className="space-y-4">
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              className="commLeftRightPadding text-left mt-2"
            >
              <h5>{props?.successmodaldata?.successMsg}</h5>
            </Col>
          </Row>

          <Row className="justify-end">
            <Col xs={4} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                onClick={() => okConfirm()}
                className="btn btn-primary w-full justify-center rounded-md"
              >
                OK
              </button>
            </Col>
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  );
});

export default AuctionSuccessModal;
